import { Navigate } from "react-router-dom";
import './details.css'

function Details() {

    if (window.sessionStorage.getItem("loggedIn") !== "TRUE") {
        return <Navigate to="/" />
    }

    return (
        <div className="details-list">
            <div className="details-list-child">
                <p className="detail-item"><b className="detail-header">Date:</b> January 17th, 2027 (the Sunday of MLK Weekend)</p>
                <p className="detail-item"><b className="detail-header">Time:</b> Mid-morning</p>
                <p className="detail-item"><b className="detail-header">Address: </b> 84 Beacon St, Boston, MA 02108 </p>
                <p className="detail-item"><b className="detail-header">Where: </b> <a href="https://www.hampshirehouse.com" target="blank">Hampshire House</a></p>

                <p className="detail-item"><b className="detail-header">Attire:</b> Festive/semi-formal. <br /> What would you wear to a holiday brunch? Consider…</p>

                <br />

                <p className="detail-item"><b className="detail-header">Sequence of Events:</b></p>
                <p className="detail-item">10:00am - Ceremony</p>
                <p className="detail-item">10:30am - Cocktail reception</p>
                <p className="detail-item">12:00pm - Brunch</p>
                <p className="detail-item">01:00pm - Cake & Coffee</p>
                <p className="detail-item">01:30pm - Dancing</p>
                <div style={{height:50}}></div>
            </div>
        </div>
    )
}

export default Details;